const createShareConfigFormData = () => ({
    agencyHubId: '',
    isMutualShared: true,
    isDisplayedOnOrder: false,
    shareDelaySecond: 0,
    feeRate: 100,
    workerFeeRate: 0,
    storeFeeRate: 100,
    storeManagementFeeRate: 100,
});
export default createShareConfigFormData;
